export const update = {
  form: {
    name: 'Name',
    price: 'Price',
    netWeightG: 'Content weight (g)',
    netWeightMl: 'Content weight (ml)',
    specificGravity: 'Specific gravity',
    costPerMl: 'Cost per ml',
    remainingQuantity: 'Remaining quantity',
    thresholdQuantity: 'Threshold quantity',
    g: 'g',
    ml: 'ml',
    bin: 'bin',
    tankInfo: 'Tank info',
    tankNo: 'Tank no',
    submit: 'Submit',
    requireName: 'Please input name',
    requirePrice: 'Please input price',
    requireQuantity: 'Please input quantity',
    requireRemainingQuantity: 'Please input remaining quantity',
    requireUnit: 'Please select units',
    requireAnnouncements: 'Please select announcement level',
    requireSpecificGravity: 'Please input specific gravity',
    requireCostPerMl: 'Please input cost per ml',
    requireThresholdQuantity: 'Please input threshold quantity',
    requireNetWeightG: 'Please input content weight (g)',
    requireNetWeightMl: 'Please input content weight (ml)',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
    cancel: 'Cancel',
    update: 'Update',
  },
  pageHeader: {
    title: 'Edit Detergent',
    back: 'Back',
  },
}
